const PURCHASE_LEDGER_TYPES = {
    DETAILED: { value: 1, description: "detailed" },
    DAILY: { value: 2, description: "daily" },
    RESUME: { value: 3, description: "resume" },
}

export default PURCHASE_LEDGER_TYPES